import React from "react";

import cn from "classnames";

import styles from "./CheckboxInput.module.scss";

const Checkbox = ({ register, label, errors }) => {
  return (
    <label className={cn(styles.Checkbox, errors.agree && styles.Error)}>
      <input type="checkbox" className={cn(styles.Input, "visually-hidden")} value="" {...register(label, { required: "Отправка возможна после того, как вы согласитесь на обработку данных." })}  />

      <span className={styles.StyledCheckbox}></span>
    </label>
  );
};

export default Checkbox;
